module.exports = __webpack_public_path__ + "056f65977df89a2977388ef423ca3459.jpg";